'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { CurrentNetworkProvider, useCurrentNetworkContext, } from './contexts/CurrentNetworkContext';
import { CurrentUserProvider, useCurrentUserContext, } from './contexts/CurrentUserContext';
import { DayjsProvider, useDayjsContext } from './contexts/DayjsContext';
import { NavigateToProvider, useNavigateToContext, } from './contexts/NavigateToProvider';
import { CurrentTopicProvider, useCurrentTopicContext, } from './contexts/TopicContext';
export const useDefaultAppContexts = () => {
    const { dayjs, locale } = useDayjsContext();
    const { currentUser, updateCurrentUser } = useCurrentUserContext();
    const { currentTopic, updateCurrentTopic } = useCurrentTopicContext();
    const { currentNetwork, updateCurrentNetwork } = useCurrentNetworkContext();
    const { navigateTo } = useNavigateToContext();
    return {
        dayjs,
        currentUser,
        currentNetwork,
        currentTopic,
        locale,
        navigateTo,
        updateCurrentUser,
        updateCurrentNetwork,
        updateCurrentTopic,
    };
};
const DefaultAppContexts = ({ children, currentNetwork, currentTopic, currentUser, locale, navigateTo, }) => (_jsx(DayjsProvider, { locale: locale, children: _jsx(CurrentUserProvider, { currentUser: currentUser, children: _jsx(CurrentNetworkProvider, { currentNetwork: currentNetwork, children: _jsx(CurrentTopicProvider, { currentTopic: currentTopic, children: _jsx(NavigateToProvider, { navigateTo: navigateTo, children: children }) }) }) }) }));
export { DefaultAppContexts };
//# sourceMappingURL=DefaultAppContexts.js.map